import React from 'react';
import PropTypes from 'prop-types';
import RadioButtonsGroup from '../../components/widgets/RadioButtonsGroup';
import Icon, { IconSizes } from '../../components/foundations/Icon';
import { SCHEDULE_FREQUENCIES, TRANSLATION_KEY } from '../constants';
import css from './ScheduleFrequencyOptions.css';

const MODAL_KEY = `${TRANSLATION_KEY}.SCHEDULE_MODAL`;

const ScheduleFrequencyOptions = ({ frequency, onChange }) => {
    const radioItems = Object.values(SCHEDULE_FREQUENCIES).map(option => {
        const optionKey = `${MODAL_KEY}.${option.toUpperCase()}`;
        return {
            id: option,
            label: optionKey,
            description: `${optionKey}_DESCRIPTION`,
            checked: option === frequency,
            tag: option === frequency ? <Icon name="check" size={IconSizes.SMALL} interactive={false} /> : null,
            tagClassName: css.selectedCheck,
        };
    });

    return (
        <RadioButtonsGroup
            radioItems={radioItems}
            className={css.group}
            itemsClassName={css.optionRow}
            checkmarkClassName={css.hiddenRadio}
            descriptionClassName={css.optionDescription}
            onChange={item => onChange(item.id)}
        />
    );
};

ScheduleFrequencyOptions.propTypes = {
    frequency: PropTypes.oneOf(Object.values(SCHEDULE_FREQUENCIES)).isRequired,
    onChange: PropTypes.func.isRequired,
};

export default ScheduleFrequencyOptions;
